<cc-section>
  <form [formGroup]="overallReportsForm" class="flex-direction-column">
    <cc-box>
      <div class="report-container header" header box>
        <span translate>REPORTS.ACCOUNT_LEVEL_REPORTS</span>
      </div>
      <div content box>
        <div class="report-container flex-between align-item-center content">
          <label translate>REPORTS.SPECIFY_DATE_RANGE</label>
          <div class="date-picker-wrapper">
            <cc-date-range-picker (selected)="changeDateRange($event, overallReportsForm)"
                                  [timePicker]="false"></cc-date-range-picker>
          </div>
        </div>
        <div class="report-container flex-between align-item-center content border-top">
          <div>
            <label translate>REPORT.CALL_COST_SUMMARY</label>
            <span class="tooltip-wrap help-icon inline">
                  <i
                    class="material-icons t-minus-2 grey-text text-xs tooltip-hover-icon help-icon m-l-xs">help_outline</i>
                  <span
                    class="tooltip-cc box-border box-radius text-xs p-a-sm pos-abt min-w-200 _300 opacity-1 z-index-10 last-tooltip"
                    translate>REPORT.DESCRIPTION.CALL_COST_SUMMARY</span>
                </span>
          </div>
          <div class="w-30 button-container">
            <button
              mat-raised-button
              [disabled]="inProgress"
              (click)="downloadOverallReport()"
              color="primary-full"
              class="pull-right">
              <span translate>REPORTS.EXPORT</span>
            </button>
          </div>
        </div>
      </div>
    </cc-box>
  </form>
</cc-section>
